import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import SlateViewSearchResult from 'components/SlateViewSearchResult/SlateViewSearchResult';
import { openSlateInPane } from 'store/actions/slatePane';
import { fetchSlatesForSearch } from 'store/actions/slateViews';

const mapStateToProps = (state) => {
  return {
    slates: state.slateViews.searchResultSlates,
    searchResultRowCount: state.slateViews.searchResultRowCount,
    searchString: state.slateViews.searchString,
    currentAccount: state.accounts.currentAccount,
    currentUser: state.currentUser,
  };
};

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, {
      openSlateInPane,
      fetchSlatesForSearch,
    })(SlateViewSearchResult),
  ),
);
